"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInRequest = void 0;
var error_1 = require("./error");
var SignInRequest = /** @class */ (function () {
    function SignInRequest(_a) {
        var identity = _a.identity, password = _a.password;
        this.identity = identity;
        this.password = password;
        if (!this.identity || !this.password) {
            throw new error_1.ValidationError("A sign-in request was generated. The request is rejected because a valid identity and a password are required.");
        }
    }
    return SignInRequest;
}());
exports.SignInRequest = SignInRequest;
//# sourceMappingURL=signInRequest.js.map